/**
 * /overview — Link Admin platform Overview (LADM-OVERVIEW).
 *
 * Backed KPI dashboard on `GET /_platform/dashboard`: MRR, tenants, active
 * subscriptions, trials, and seats billed.
 */
import { createFileRoute } from "@tanstack/react-router";
import { PlatformDashboardScreen } from "../features/dashboard/PlatformDashboardScreen";

export const Route = createFileRoute("/_auth/overview")({
  staticData: {
    breadcrumb: { labelKey: "link-admin:overview.title" },
  },
  component: PlatformDashboardScreen,
});
